var _rect, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlertGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 18.6559C35.0021 21.4258 34.1826 24.134 32.6451 26.438C31.1076 28.7419 28.9212 30.538 26.3626 31.599C23.804 32.6599 20.9881 32.9381 18.2714 32.3983C15.5547 31.8584 13.0591 30.5248 11.1005 28.5662C9.14192 26.6076 7.80833 24.1121 7.26848 21.3953C6.72864 18.6786 7.0068 15.8628 8.06777 13.3042C9.12874 10.7456 10.9248 8.55917 13.2288 7.02166C15.5327 5.48415 18.241 4.66461 21.0108 4.66675C24.7201 4.66962 28.2766 6.1444 30.8995 8.76725C33.5223 11.3901 34.9971 14.9466 35 18.6559Z",
    fill: "#C5E387"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3711 34.1365C16.0636 34.1365 16.0636 21.2308 16.0636 21.2308C16.0636 17.808 17.3211 14.5254 19.5595 12.1052C21.7979 9.68488 24.8338 8.3252 27.9994 8.3252C31.165 8.3252 34.2009 9.68488 36.4393 12.1052C38.6777 14.5254 39.9353 17.808 39.9353 21.2308C39.9353 21.2308 39.9353 34.1365 41.6277 34.1365H14.3711Z",
    stroke: "#001698",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 34.1362H43",
    stroke: "#001698",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5381 34.1362C34.5381 36.011 33.8493 37.809 32.6233 39.1346C31.3972 40.4603 29.7344 41.205 28.0005 41.205C26.2666 41.205 24.6037 40.4603 23.3777 39.1346C22.1517 37.809 21.4629 36.011 21.4629 34.1362",
    stroke: "#001698",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.002 8.31313V5",
    stroke: "#001698",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertGreen);
export default __webpack_public_path__ + "static/media/alertGreen.bb9a174ce5aaf68bbd6657ef55fa8bbf.svg";
export { ForwardRef as ReactComponent };